import React from "react";
import { ShoppingBasket, HeartHandshake, Sprout } from "lucide-react";
import { Reveal, WfButton } from "@/components/site/primitives";
import { scrollToId } from "@/lib/scrollTo";

const callouts = [
  { id: "where-to-buy", target: "events", icon: ShoppingBasket, title: "Where to buy crops" },
  { id: "support", target: "get-involved", icon: HeartHandshake, title: "I want to support" },
  { id: "who-we-are", target: "about", icon: Sprout, title: "Who we are" },
];

export const FinalCTAV2 = () => {
  const go = (id) => (e) => { e.preventDefault(); scrollToId(id); };
  return (
    <section id="get-involved" aria-labelledby="final-cta-v2-heading" className="wf-grain relative overflow-hidden">
      <img src="/images/wf/farm-fabiola.jpg" alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover" />
      <div aria-hidden="true" className="absolute inset-0 bg-[var(--wf-maroon)]/85" />
      <div aria-hidden="true" className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-black/30" />

      <div className="wf-container relative py-20 text-center sm:py-28 lg:py-36">
        <Reveal className="mx-auto max-w-3xl">
          <p className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-[rgba(255,253,248,0.85)]">
            <span aria-hidden="true" className="h-px w-6 bg-[rgba(255,253,248,0.6)]" />
            Join the community
            <span aria-hidden="true" className="h-px w-6 bg-[rgba(255,253,248,0.6)]" />
          </p>
          <h2 id="final-cta-v2-heading" className="mt-5 font-serif text-4xl font-semibold leading-[1.05] text-[var(--wf-paper)] sm:text-5xl lg:text-6xl [text-shadow:0_2px_20px_rgba(0,0,0,0.4)]">
            Every farmer’s success starts with a community that shows up.
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-base leading-7 text-[rgba(255,253,248,0.88)]">
            Shop the harvest, give what you can, or get to know the people growing it.
          </p>
          <div className="mt-9">
            <WfButton as="a" href="#get-involved" onClick={go("get-involved")} variant="light" withArrow className="text-base" data-testid="final-cta-get-involved-button">
              Get Involved
            </WfButton>
          </div>
        </Reveal>

        <div className="mx-auto mt-12 grid max-w-3xl grid-cols-1 gap-3 sm:grid-cols-3">
          {callouts.map((c, idx) => {
            const Icon = c.icon;
            return (
              <Reveal key={c.id} delay={0.07 * idx}>
                <button type="button" onClick={() => scrollToId(c.target)} data-testid={`final-cta-callout-${c.id}`} className="group flex w-full items-center justify-center gap-3 rounded-sm border border-white/20 bg-white/10 px-5 py-4 text-left backdrop-blur-sm transition-colors duration-300 hover:bg-white/20 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--wf-maroon)]">
                  <Icon className="h-5 w-5 text-[var(--wf-sage)]" aria-hidden="true" />
                  <span className="font-serif text-base font-semibold text-white">{c.title}</span>
                </button>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
